import { render, staticRenderFns } from "./TabelaAlunos.vue?vue&type=template&id=c192f6c0&"
import script from "./TabelaAlunos.vue?vue&type=script&lang=js&"
export * from "./TabelaAlunos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports